import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/api";
import { CreateDeviceRequest, DevicePaginateRequest, UpdateDeviceRequest } from "../types/device";

export const getDeviceTypeList = () =>
  axiosInstance.get(API_ENDPOINTS.getDeviceTypeList);

export const getDevicePaginate = (payload: DevicePaginateRequest) =>
  axiosInstance.post(API_ENDPOINTS.getDevicePaginate, payload);

export const createDevice = (payload: CreateDeviceRequest) =>
  axiosInstance.post(API_ENDPOINTS.createDevice, payload);

export const updateDevice = (payload: UpdateDeviceRequest) =>
  axiosInstance.put(API_ENDPOINTS.updateDevice, payload);

export const deleteDevice = (id: number) =>
  axiosInstance.delete(API_ENDPOINTS.deleteDevice(id));
